(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/footer.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/footer.js');
'use strict';

const {
  GeneralTermsDocLink
} = svs.playerRegistration.components;
const Footer = _ref => {
  let {
    isRetail = false
  } = _ref;
  return React.createElement("div", {
    className: "player-registration-footer u-border-top-1 padding-top-1"
  }, isRetail && React.createElement("p", null, "V\xE5ra", ' ', React.createElement(GeneralTermsDocLink, null)), React.createElement("p", {
    className: "margin-bottom-0"
  }, "Har du fr\xE5gor? Kontakta Svenska Spels", ' ', React.createElement("a", {
    className: "u-text-decoration-underline",
    href: svs.core.urlMapping.get('customerServiceContact'),
    rel: "noreferrer",
    target: "_blank"
  }, "kundservice.")));
};
svs.playerRegistration.components.Footer = Footer;

 })(window);